import React from 'react';

import ChatbotProvider from '~chatbot/provider/ChatbotProvider';
import ChatbotWidget from '~chatbot/ui/ChatbotWidget';

function SupportChatbot({
  chatbotSlug, header, logo, extraClass, errorNotice,
}) {
  return (
    <ChatbotProvider chatbotSlug={chatbotSlug}>
      <ChatbotWidget
        header={header}
        logo={logo}
        extraClass={extraClass}
        errorNotice={errorNotice}
      />
    </ChatbotProvider>
  );
}

export default SupportChatbot;
